/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automation_Update_FieldInputs */

const cs_automation_update_field = /** @type {(inputs: Automation_Update_FieldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pole`)
};

const en_automation_update_field = /** @type {(inputs: Automation_Update_FieldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Field`)
};

/**
* | output |
* | --- |
* | "Field" |
*
* @param {Automation_Update_FieldInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const automation_update_field = /** @type {((inputs?: Automation_Update_FieldInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automation_Update_FieldInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_automation_update_field(inputs)
	return cs_automation_update_field(inputs)
});